var exports = {
  "Y": "xf0b3b88a--61f105--tooltip",
  "A": "xf0b3b88a--61f105--item",
};

module.exports = exports;
